import React, { useEffect, useState } from 'react'
import client from '../../client/Client'
import HeaderBanner from '../ui/HeaderBanner'

interface subChild {
  children: Array<{
    text: string
  }>
}

interface Child {
  Title: string,
  image: {
    asset: {
      _ref: string
    }
  },
  TheProgram: subChild[]
}

interface myData {
  SocialPrograms: Child[];
}

const SocialPrograms = () => {
  const [data, setData] = useState<myData>()

  useEffect(() => {
    client.fetch('*[_type == "Programs"]')
      .then((result) => {
        setData(result[0]);
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
      });
  }, [])

  const getImageUrl = (ref: string) => {
    return `https://cdn.sanity.io/images/79vgbaej/production/${ref.slice(6, -4)}.${ref.slice(-3)}`;
  };

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 pt-32 pb-24">
      <div className="fixed left-1/2 transform -translate-x-1/2 bottom-0 pointer-events-none -z-1" aria-hidden="true">
        <svg width="1360" height="578" viewBox="0 0 1360 578" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="illustration-01">
              <stop stopColor="#FFF" offset="0%" />
              <stop stopColor="#EAEAEA" offset="77.402%" />
              <stop stopColor="#DFDFDF" offset="100%" />
            </linearGradient>
          </defs>
          <g fill="url(#illustration-01)" fillRule="evenodd">
            <circle cx="1232" cy="128" r="128" />
            <circle cx="155" cy="443" r="64" />
          </g>
        </svg>
      </div>
      
      <HeaderBanner title='Social Program' />
      
      <div className="text-left space-y-8 pt-12">
        {data?.SocialPrograms?.map((item, index) => (
          <div 
            key={index} 
            className="bg-gray-50 border-l-4 border-red-500 p-6 rounded-lg shadow-sm hover:shadow-md transition-all duration-300"
          >
            {/* Program Header */}
            <h1 className="text-xl font-bold leading-tight tracking-tight text-gray-800 mb-6">
              {item.Title}
            </h1>
            
            {/* Program Content */}
            <div className="flex flex-col md:flex-row gap-6">
              {/* Image Section */}
              {item.image && (
                <div className="md:w-1/2 lg:w-2/5">
                    <img 
                      className="w-full h-64 md:h-80 rounded-lg object-cover object-center"
                      src={getImageUrl(item.image.asset._ref)} 
                      alt={item.Title} 
                    />
                </div>
              )}
              {/* Text Content Section - No inner container */}
              <div className={`${item.image ? 'md:w-1/2 lg:w-3/5' : 'w-full'}`}>
                <div className="space-y-4 text-gray-700 leading-relaxed">
                  {item.TheProgram.map((paragraph, pIndex) => (
                    <p key={pIndex}>
                      {paragraph.children[0].text}
                    </p>
                  ))}
                </div>
              </div>
            </div>
          </div>
        ))}

        {/* Additional Information Section */}
        <div className="bg-red-50 border-l-4 border-red-500 p-6 rounded-lg">
          <h3 className="text-lg font-semibold text-red-600 mb-2">
            Questions About Social Programs?
          </h3>
          <p className="text-gray-700">
            For more information about our social programs, please contact:{' '}
            <a 
              className='text-red-600 hover:text-red-800 font-medium underline' 
              href='mailto:info@ssd-multiconf.org'
            >
              info@ssd-multiconf.org
            </a>
          </p>
        </div>
      </div>
    </div>
  )
}

export default SocialPrograms